'use strict';
const mmWidgets = require('../widgets/mm-widgets'),
	bounds = require('../models/text-margin-bounds');

mmWidgets.fn.themeStyleTextMarginWidget = function (mapThemeModel) {
	const getCurrentSize = (themeNodeStyle) => {
			const size = mapThemeModel.getThemeAttribute(['node'], [themeNodeStyle, 'default'], ['text', 'margin']);
			return parseFloat(size) || bounds.min;
		},
		setSize = (themeNodeStyle, size) => {
			mapThemeModel.overrideThemeAttribute(['node', themeNodeStyle, 'text', 'margin'], size || undefined);
		},
		incrementNodeWidth = (themeNodeStyle, increment) => {
			const current = getCurrentSize(themeNodeStyle),
				newSize = current + increment;

			if (newSize < bounds.min) {
				setSize(themeNodeStyle, bounds.min);
			} else if (newSize > bounds.max) {
				setSize(themeNodeStyle, bounds.max);
			} else {
				setSize(themeNodeStyle, newSize);
			}
		},
		increment = function (themeNodeStyle) {
			incrementNodeWidth(themeNodeStyle, 1);
		},
		decrement = function (themeNodeStyle) {
			incrementNodeWidth(themeNodeStyle, -1);
		},
		reset = (themeNodeStyle) => {
			setSize(themeNodeStyle, false);
		},
		actions = {increment, decrement, reset};

	return mmWidgets.each(this, function () {
		const widget = this;
		widget.click(() => {
			const themeNodeStyle = widget.attr('data-mm-theme-node-style'),
				operation = widget.attr('data-mm-text-margin');
			actions[operation](themeNodeStyle);
		});
	});
};

